{
  "modal_message": "Haben Sie schon die Gucci App?",
  "modal_yes": "JAWOHL",
  "modal_no": "NEIN"
}
